import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=aced00f8&scoped=true"
import script from "./Exception.vue?vue&type=script&lang=js"
export * from "./Exception.vue?vue&type=script&lang=js"
import style0 from "./Exception.vue?vue&type=style&index=0&id=aced00f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aced00f8",
  null
  
)

export default component.exports